<template>
  <div class="p-4">
    <div class="loader-overlay" v-if="isDataFetch">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        class="text-white"
      ></b-spinner>
    </div>

    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Quote list</h4>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-sm btn-primary" @click="fnGoNewQuote()">
              New
            </button>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>

          <div class="status-box item">
            <label for="paginate" class="mb-0">Status</label>
            <select
              v-model="selectedStatus"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All Status</option>
              <option
                v-for="item in optionStatus"
                :key="item.value"
                :value="item.value"
              >
                {{ item.text }}
              </option>
            </select>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>

        <div class="table-responsive table-sm">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item">
                  <a
                    href="javascript:void(0)"
                    @click.prevent="fnChangeSort('id')"
                    >Quote Id</a
                  >
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">Source</th>
                <th class="header-item">
                  <a href="javascript:void(0)">Client name</a>
                </th>
                <th class="header-item">Vehicle</th>
                <th class="header-item">Income</th>
                <th class="header-item">Est. Delivery Date</th>
                <th class="header-item">
                  <a
                    href="javascript:void(0)"
                    @click.prevent="fnChangeSort('createdBy')"
                    >Created By</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'createdBy'"
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'createdBy'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a
                    href="javascript:void(0)"
                    @click.prevent="fnChangeSort('created_at')"
                    >Created</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'created_at'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'created_at'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center">
                  <a
                    href="javascript:void(0)"
                    @click.prevent="fnChangeSort('sortOrder')"
                    >Status</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'sortOrder'"
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'sortOrder'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in getQuotePaginateData.data" :key="row.id">
                <td>{{ row.id }}</td>
                <td>{{ row.quoteSource }}</td>
                <td>{{ row.client }}</td>
                <td>{{ row.vehicleInfo }}</td>
                <td>${{ row.income | with-decimal }}</td>
                <td>{{ row.edd | dateConvertDDMMYYYY }}</td>

                <td>
                  <span v-if="row.createdBy">{{ row.createdBy }}</span>
                  <span else></span>
                </td>
                <td>
                  {{ row.created_at | dateConvertDDMMYYYY }}
                </td>
                <td class="v-td-center">
                  <WDQuoteStatusBadge :status="row.status"></WDQuoteStatusBadge>
                </td>
                <td class="v-td-center">
                  <div class="d-flex">
                    <a
                      @click="fnGoViewQuote(row.id)"
                      v-b-tooltip.hover
                      title="View quote"
                      class="d-inline pr-2"
                      ><i class="far fa-eye text-primary"></i
                    ></a>
                    <a
                      @click="fnGoEditQuote(row.id)"
                      v-b-tooltip.hover
                      title="Update quote"
                      class="d-inline pr-2"
                      ><i class="far fa-edit text-primary"></i
                    ></a>
                    <div class="d-inline pr-2">
                      <appModalQuoteTransfer :rowData="row">
                      </appModalQuoteTransfer>
                    </div>
                    <appModalMsgDealer
                      :quoteId="row.id"
                      :quote="row"
                      class="d-inline pr-2"
                    >
                    </appModalMsgDealer>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="10">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage(recordsPerPage)"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getQuotePaginateData"
                        @pagination-change-page="fnGetQuoteList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from 'laravel-vue-pagination'
import * as authService from '../../../services/auth.service'
import * as taxTableService from '../../../services/taxTable.service'
import { mapGetters, mapActions } from 'vuex'
import { optionStatus } from '../../../services/data.service'
import appModalDocumentsUpload from '../../../components/quote/ModalDocumentsUpload.vue'
import appModalMsgDealer from '../../../components/quote/ModalMsgDealer.vue'
import WDQuoteStatusBadge from '../../../components/wd/WDQuoteStatusBadge.vue'
import appModalQuoteTransfer from '../../../components/admin/ModalQuoteTransfer.vue'

export default {
  name: 'dealerQuoteList',
  components: {
    pagination,
    appModalDocumentsUpload,
    appModalMsgDealer,
    WDQuoteStatusBadge,
    appModalQuoteTransfer
  },
  data() {
    return {
      isDataFetch: true,
      optionStatus: optionStatus,
      quoteCalculation: {},
      loginUserObj: {},
      dealerUserId: '',
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'sortOrder',

      paginate: {
        dealerUserId: '',
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'sortOrder'
      }
    }
  },
  computed: {
    ...mapGetters([
      'getQuoteSingle',
      'getQuotePaginateData',
      'getQuotePaginate'
    ])
  },

  methods: {
    ...mapActions(['fetchQuoteSingle', 'fetchQuotePaginate']),
    fnGoNewQuote() {
      this.$router.push({ name: 'dealer.quoteNew' })
    },
    fnGoViewQuote(id) {
      this.$router.push({ name: 'dealer.quoteView', params: { quoteId: id } })
    },
    fnGoEditQuote(id) {
      this.$router.push({ name: 'dealer.quoteEdit', params: { quoteId: id } })
    },

    fnGetQuoteList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        dealerUserId: this.dealerUserId,
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchQuotePaginate(objNew)
    },
    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        dealerUserId: this.dealerUserId,
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchQuotePaginate(objNew)
    },
    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        dealerUserId: this.dealerUserId,
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchQuotePaginate(objNew)
    },
    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        dealerUserId: this.dealerUserId,
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchQuotePaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''

      let obj1 = this.paginate
      let obj2 = {
        dealerUserId: this.dealerUserId,
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'sortOrder'
      }

      let objNew = { ...obj1, ...obj2 }

      this.fetchQuotePaginate(objNew)
    }
  },
  created() {
    this.loginUserObj = authService.getUserFromToken()
    this.dealerUserId = this.loginUserObj.id

    // Store taxTable information in local storage
    taxTableService.storeTaxTable()
  },

  async mounted() {
    this.isDataFetch = true
    let obj1 = this.paginate
    let obj2 = {
      dealerUserId: this.dealerUserId,
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'sortOrder'
    }

    let objNew = { ...obj1, ...obj2 }

    this.fetchQuotePaginate(objNew)
    this.isDataFetch = false
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>
